export function infoSlider() {
    const $window = $(window)
    const tabbedSliderWrap = $('.info-slider-holder');
    tabbedSliderWrap.each(function () {
        const tabbedSliderNav = $(this).find('.info-slider-nav');
        const tabbedSliderContent = $(this).find('.info-slider-big-card');
        let slideShow = 3;
        if (tabbedSliderNav.data("slide-show")) {
            slideShow = tabbedSliderNav.data("slide-show");
        }
        let sliderSettings = {
            arrows: false,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: tabbedSliderContent,
            focusOnSelect: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: slideShow,
                        variableWidth: false
                    }
                }
            ]
        }

        tabbedSliderContent.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: tabbedSliderNav,
            infinite: false,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
        });
        tabbedSliderNav.slick(sliderSettings);
    });
    $window.on('scroll load', function () {
        tabbedSliderWrap.each(function () {
            let winTop = $window.scrollTop();
            let parentSlider = $(this);
            let parentSliderTop = parentSlider.offset().top;
            const tabbedSliderContent = parentSlider.find('.info-slider-big-card');
            if (winTop > parentSliderTop - $window.innerHeight() / 2 && !tabbedSliderContent.hasClass("play-animation") && winTop < parentSliderTop + parentSlider.innerHeight() - $window.innerHeight() / 2) {
                tabbedSliderContent.addClass("play-animation").slick("slickPlay");
            }
            if (winTop < parentSliderTop - $window.innerHeight() / 2 && tabbedSliderContent.hasClass("play-animation")) {
                tabbedSliderContent.removeClass("play-animation").slick("slickPause");
            }
            if (winTop > parentSliderTop + parentSlider.innerHeight() && tabbedSliderContent.hasClass("play-animation")) {
                tabbedSliderContent.removeClass("play-animation").slick("slickPause");
            }
        });
    });
    $window.on('resize', function () {
        tabbedSliderWrap.each(function () {
            let $this = $(this);
            let numberOfSlides = $this.find('.info-slider-nav .item').length;
            let slidesShown = $this.find('.info-slider-nav').slick('slickGetOption', 'slidesToShow');
            if (numberOfSlides <= slidesShown) {
                setTimeout(() => {
                    $this.find('.info-slider-nav').find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
                }, 100);
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/infoSlider.js